import { SVGProps } from "react";

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "12"} height={props.height || "12"} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.19231 9.63461C7.64573 9.63461 9.63461 7.64573 9.63461 5.19231C9.63461 2.73889 7.64573 0.75 5.19231 0.75C2.73889 0.75 0.75 2.73889 0.75 5.19231C0.75 7.64573 2.73889 9.63461 5.19231 9.63461Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.2505 11.25L8.33398 8.3335" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
